module.exports = __webpack_public_path__ + "static/media/option-for-leasing_2.2b19f9fb.svg";